import { Routes } from '@angular/router';
import { assemblerGuardFn } from './core/guards/assembler.guard';
import { authGuardFn } from './core/guards/auth.guard';
import { preventLeaveOnErrorGuard } from './core/guards/block-on-errror.guard';
import { loginGuardFn } from './core/guards/login.guard';
import { LoginComponent } from './shared/components/login/login.component';

export const routes: Routes = [
  {
    path: 'start',
    loadComponent: () => import('./shared/components/dashboard/dashboard.component').then(c => c.DashboardComponent),
    data: {preload: true},
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  { path: 'login', component: LoginComponent, canActivate: [loginGuardFn] },
  {
    path: 'custSetup',
    loadComponent: () =>
      import(
        './shared/components/settings/customer-setup/customer-setup.component'
      ).then((c) => c.CustomerSetupComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'webquotation/catalogue/:lineId', // lineId = salesBasketId || salesId
    loadComponent: () =>
      import('./shared/components/catalogue/catalogue.component').then(
        (c) => c.CatalogueComponent
      ),
    canActivate: [authGuardFn],
  },
  {
    path: 'webquotation/:id/:basketTransId',
    loadComponent: () =>
      import(
        './shared/components/webquotation/webquotation-details-outlet/webquotation-details-outlet.component'
      ).then((c) => c.WebquotationDetailsOutletComponent),
    canActivate: [authGuardFn],
  },
  {
    path: 'webquotation/:id',
    loadComponent: () =>
      import(
        './shared/components/webquotation/webquotation-details-outlet/webquotation-details-outlet.component'
      ).then((c) => c.WebquotationDetailsOutletComponent),
    canActivate: [authGuardFn],
  },
  {
    path: 'webquotations/:tab',
    loadComponent: () =>
      import(
        './shared/components/webquotation/webquotation-list/webquotation-list.component'
      ).then((c) => c.WebquotationListComponent),
    canActivate: [authGuardFn],
  },
  {
    path: 'webquotations',
    loadComponent: () =>
      import(
        './shared/components/webquotation/webquotation-list/webquotation-list.component'
      ).then((c) => c.WebquotationListComponent),
      data: {preload: true},
    canActivate: [authGuardFn],
  },
  {
    path: 'webquotationChangedFigureConfig/:id/:basketTransId',
    loadComponent: () =>
      import(
        './shared/components/webquotation/webquotation-details-outlet/webquotation-details-outlet.component'
      ).then((c) => c.WebquotationDetailsOutletComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'controlMeasure/:id',
    loadComponent: () =>
      import(
        './shared/components/webquotation/webquotation-details-outlet/webquotation-details-outlet.component'
      ).then((c) => c.WebquotationDetailsOutletComponent),
    canActivate: [authGuardFn],
  },
  {
    path: 'salesQuotation/:id',
    loadComponent: () =>
      import(
        './svf/components/salesquotation/salesquotation-details/salesquotation-details.component'
      ).then((c) => c.SalesquotationDetailsComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'salesQuotations',
    loadComponent: () =>
      import(
        './svf/components/salesquotation/salesquotation-list/salesquotation-list.component'
      ).then((c) => c.SalesquotationListComponent),
      data: {preload: true},
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'salesOrders',
    loadComponent: () =>
      import(
        './shared/components/salesorder/salesorder-list-outlet/salesorder-list-outlet.component'
      ).then((c) => c.SalesorderListOutletComponent),
      data: {preload: true},
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'salesOrder/catalogue/:lineId',
    loadComponent: () =>
      import('./shared/components/catalogue/catalogue.component').then(
        (c) => c.CatalogueComponent
      ),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'salesOrder/:id/:inventTransId',
    loadComponent: () =>
      import(
        './shared/components/salesorder/salesorder-details-outlet/salesorder-details-outlet.component'
      ).then((c) => c.SalesorderDetailsOutletComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'salesOrder/:id',
    loadComponent: () =>
      import(
        './shared/components/salesorder/salesorder-details-outlet/salesorder-details-outlet.component'
      ).then((c) => c.SalesorderDetailsOutletComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'portalAdmin',
    loadComponent: () =>
      import(
        './mf/components/portal-administration/portal-administration.component'
      ).then((c) => c.PortalAdministrationComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'leads',
    loadComponent: () =>
      import('./shared/components/leads/lead-list/lead-list.component').then(
        (c) => c.LeadListComponent
      ),
      data: {preload: true},
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'lead/:id',
    loadComponent: () =>
      import(
        './shared/components/leads/lead-details/lead-details.component'
      ).then((c) => c.LeadDetailsComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'aftermarketIssue/:id',
    loadComponent: () =>
      import(
        './aftermarket/components/aftermarket-issue/aftermarket-issue.component'
      ).then((c) => c.AftermarketIssueComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'aftermarketIssue',
    loadComponent: () =>
      import(
        './aftermarket/components/aftermarket-issue/aftermarket-issue.component'
      ).then((c) => c.AftermarketIssueComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'aftermarketIssues',
    loadComponent: () =>
      import(
        './aftermarket/components/aftermarket-issues/aftermarket-issues.component'
      ).then((c) => c.AftermarketIssuesComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'lifecycle/tools',
    loadComponent: () =>
      import('./life-cycle/components/move-issues/move-issues.component').then(
        (c) => c.MoveIssuesComponent
      ),
    // NOTE: This one is public - should it be public?
  },
  {
    path: 'lifecycle',
    loadComponent: () =>
      import('./life-cycle/components/lifecycle/lifecycle.component').then(
        (c) => c.LifecycleComponent
      ),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'notifications',
    loadComponent: () =>
      import('./shared/components/notifications/notifications.component').then(
        (c) => c.NotificationsComponent
      ),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'proffsportalen-users',
    loadComponent: () =>
      import(
        './svf/components/proffsportalen/user-list/proffsportalen-user-list.component'
      ).then((c) => c.ProffsportalenUserListComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'proffsportalen-user/:id',
    loadComponent: () =>
      import(
        './svf/components/proffsportalen/user-details/proffsportalen-user-details.component'
      ).then((c) => c.ProffsportalenUserDetailsComponent),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'configurator/:configType/:configId/:configTransId',
    loadComponent: () =>
      import('./shared/components/configurator-wrapper/configurator-wrapper.component').then(
        (c) => c.ConfiguratorComponent
      ),
    canActivate: [authGuardFn, assemblerGuardFn],
    canDeactivate: [preventLeaveOnErrorGuard]
  },
  {
    path: 'workOrder/:id',
    loadComponent: () =>
      import(
        './mf/components/workorder/workorder-details/workorder-details.component'
      ).then((c) => c.WorkorderDetailsComponent),
    canActivate: [authGuardFn],
  },
  {
    path: 'workOrders',
    loadComponent: () =>
      import(
        './mf/components/workorder/workorder-list/workorder-list.component'
      ).then((c) => c.WorkorderListComponent),
    canActivate: [authGuardFn],
  },
  {
    path: 'reset-password-custportal/:id',
    loadComponent: () =>
      import(
        './shared/components/reset-password/reset-password-kp/reset-password-kp.component'
      ).then((c) => c.ResetPasswordKpComponent),
  },
  {
    path: 'reset-password-proffsportalen/:id',
    loadComponent: () =>
      import(
        './shared/components/reset-password/reset-password-proffsportal/reset-password-proffsportal.component'
      ).then((c) => c.ResetPasswordProffsportalComponent),
  },
  {
    path: 'information',
    loadComponent: () =>
      import('./shared/components/information/information.component').then(
        (c) => c.InformationComponent
      ),
    canActivate: [authGuardFn, assemblerGuardFn],
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./shared/components/forgot-password/forgot-password.component')
    .then(c => c.ForgotPasswordComponent)
  },

  { path: '**', redirectTo: '/start', pathMatch: 'full' }, // Default fallback route
];
